import { useCustomerSignup } from "auth/signUp/signup-customer/signup-customer.service";
import Background from "shared/assets/images/svg/companyBackground.svg";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import Input from "shared/component/inputFields";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";

export const CompanyInfo = (props) => {
  const {t} = useTranslation();
  const { companyForm, setCustomerSignupData } = useCustomerSignup();
  const {
    register,
    control,
    formState: { errors },
    handleSubmit
  } = companyForm;

  const next = (data) => {
    setCustomerSignupData((cur) => ({ ...cur, ...data }));
    props.nextStep();
  };

  return (
    <form className="row justify-content-between" onSubmit={handleSubmit(next)}>
      <div className="col-lg-5 col-md-6">
        <div className="page-info">
          <img className="background" src={Background} alt="img" />
          <h1 className="title"> {t("signup.contact-info")}</h1>
          <p className="p-content">{t("signup.contact-info-detail")}</p>
          <ul className="info-steps list-unstyled">
            <Trans i18nKey="signup.contact-info-list">
              <li>By adding your company info, it will be easy to contact with you later</li>
              <li>Add the name of the company, the person in charge, and the phone number</li>
              <li>Use your email at every login</li>
            </Trans>
          </ul>
        </div>
      </div>
      <div className="col-lg-6 col-md-6">
        <div className="box-form">
          <div className="page-header">
            <div className="header-info">
              <Link to="/signup">
                <img src={Back} alt="" />
              </Link>
              <h1 className="title">{t('signup.contact-info')}</h1>
            </div>
          </div>
          <Input
            type="text"
            label={t('signup.customer-name')}
            require
            {...register("companyName")}
            error={errors.companyName?.message}
          />
          <Input
            type="text"
            label={t('signup.full-name')}
            require
            {...register("employeeName")}
            error={errors.employeeName?.message}
          />
           <Input
            type="text"
            label={t('signup.email')}
            {...register("employeeEmail")}
            error={errors.employeeEmail?.message}
          />
          <Input
            type="phone"
            name='employeePhone'
            control={control}
            label={t('signup.phone')}
            require
            error={errors.employeePhone?.message}
          />
          <h1 className="box-title">{t('signup.log-in-data')}</h1>
          <Input
            type="text"
            label={t('signup.user-name')}
            require
            {...register("userName")}
            error={errors.userName?.message}
          />
          <Input
            type="password"
            label={t('signup.password')}
            require
            {...register("employeePassword")}
            error={errors.employeePassword?.message}
          />
          <Input
            type="password"
            label={t('signup.confirm-password')}
            require
            {...register("confirmEmployeePassword")}
            error={errors.confirmEmployeePassword?.message}
          />
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <button className="btn-blue w-100" type="submit">
                {t('signup.next')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};